/**
 * gray: rgb(125, 125, 125)
 */
.icon-close::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m13.41 12 5.66-5.66a.996.996 0 1 0-1.41-1.41L12 10.59 6.34 4.93a.996.996 0 1 0-1.41 1.41L10.59 12l-5.66 5.66a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.66-5.66 5.66 5.66c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L13.43 12Z" fill="rgb(125, 125, 125)"/></svg>');
  background-repeat: no-repeat;
}

.icon-arrow-left::before {
  content: '';
  display: block;
  height: 20px;
  width: 20px;
  background-size: 20px 20px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.79 21c-.26 0-.51-.1-.71-.29l-7.29-7.29c-.78-.78-.78-2.05 0-2.83l7.29-7.29a.996.996 0 1 1 1.41 1.41L9.2 12l7.29 7.29a.996.996 0 0 1-.71 1.7Z" fill="rgb(125, 125, 125)"/></svg>');
  background-repeat: no-repeat;
}

.icon-arrow-right::before {
  content: '';
  display: block;
  height: 20px;
  width: 20px;
  background-size: 20px 20px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.21 21c.26 0 .51-.1.71-.29l7.29-7.29c.78-.78.78-2.05 0-2.83L8.92 3.3a.996.996 0 1 0-1.41 1.41L14.8 12l-7.29 7.29a.996.996 0 0 0 .71 1.7Z" fill="rgb(125, 125, 125)"/></svg>');
  background-repeat: no-repeat;
}

/**
 * white: white
 */
.icon-arrow-right.white::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.21 21c.26 0 .51-.1.71-.29l7.29-7.29c.78-.78.78-2.05 0-2.83L8.92 3.3a.996.996 0 1 0-1.41 1.41L14.8 12l-7.29 7.29a.996.996 0 0 0 .71 1.7Z" fill="white"/></svg>');
  background-repeat: no-repeat;
  margin: 0;
}

.icon-arrow-left.white::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.79 21c-.26 0-.51-.1-.71-.29l-7.29-7.29c-.78-.78-.78-2.05 0-2.83l7.29-7.29a.996.996 0 1 1 1.41 1.41L9.2 12l7.29 7.29a.996.996 0 0 1-.71 1.7Z" fill="white"/></svg>');
  background-repeat: no-repeat;
  margin: 0;
}

.icon-close.white::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m13.41 12 5.66-5.66a.996.996 0 1 0-1.41-1.41L12 10.59 6.34 4.93a.996.996 0 1 0-1.41 1.41L10.59 12l-5.66 5.66a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.66-5.66 5.66 5.66c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L13.43 12Z" fill="white"/></svg>');
  background-repeat: no-repeat;
}

/**
 * red: rgb(160 13 12)
 */
.icon-location::before {
  content: '';
  display: block;
  height: 35px;
  width: 35px;
  background-size: 35px 35px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C7.59 2 4 5.55 4 9.91c0 4.1 6.53 11.01 7.28 11.78.19.19.44.3.71.31.27 0 .52-.11.71-.29.75-.75 7.29-7.42 7.29-11.8S16.4 2 11.99 2Zm.01 17.55C9.85 17.17 6 12.41 6 9.91 6 6.65 8.69 4 12 4s6 2.65 6 5.91c0 2.68-3.83 7.33-5.99 9.64ZM12 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z" fill="rgb(160 13 12)"></path></svg>');
  background-repeat: no-repeat;
}

.icon-phone::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.12 22.02c-3.55 0-5.77-1.36-8.8-5.4A14.094 14.094 0 0 1 4.16 5.73c.32-1.07 1.08-3.57 2.88-3.71 1.1-.1 2.21-.03 3.29.2.56.14 1.04.52 1.3 1.04.7 1.59.86 3.36.44 5.05a3.2 3.2 0 0 1-1.35 1.51c-.24.16-.47.34-.67.55.04.69.27 1.35.66 1.92.58 1.1 1.44 2.03 2.49 2.69.11-.07.26-.18.36-.26.44-.44 1.04-.69 1.66-.7 1.54.14 4.47 2.01 4.88 3.77.27 1.15-.89 2.61-1.32 2.98a7.08 7.08 0 0 1-3.66 1.25ZM7.21 4.01c-.08.03-.52.3-1.13 2.3-.64 3.16.03 6.44 1.84 9.11 2.93 3.91 4.66 4.6 7.2 4.6a5.43 5.43 0 0 0 2.35-.76c.31-.31.54-.69.67-1.11-.14-.57-2.01-1.93-2.98-2.12-.14.09-.27.19-.4.29-.49.51-1.2.75-1.9.66-1.45-.39-3-2.14-3.89-3.7-.7-1.03-.99-2.29-.81-3.53.27-.65.76-1.2 1.38-1.54.23-.16.45-.35.65-.55.28-.93.06-3.17-.37-3.52-.86-.16-1.74-.21-2.61-.13Z" fill="rgb(160 13 12)" /></svg>');
  background-repeat: no-repeat;
}

.icon-clock::before {
  /* content: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="-1050 -970 1200 1200" width="30"><path class="segment-clock" d="M512 960c-282.77 0-512-229.23-512-512s229.23-512 512-512c282.77 0 512 229.23 512 512v0c0 282.77-229.23 512-512 512v0zM512 21.333c-235.641 0-426.667 191.025-426.667 426.667s191.025 426.667 426.667 426.667c235.641 0 426.667-191.025 426.667-426.667v0c0-235.641-191.025-426.667-426.667-426.667v0zM554.667 789.333h-84.992v-383.659h255.659v85.333h-170.667v298.325z" fill="rgb(160 13 12)" transform="rotate(-180)"/></svg>'); */
  content: '';
  display: block;
  height: 25px;
  width: 25px;
  background-size: 25px 25px;
  /* background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg viewbox="0 0 64 64""><path d="M 32 2 C 15.43 2 2 15.43 2 32 s 13.43 30 30 30 s 30 -13.43 30 -30 S 48.57 2 32 2 Z m 1.5 56.96 V 57.5 c 0 -0.83 -0.67 -1.5 -1.5 -1.5 s -1.5 0.67 -1.5 1.5 v 1.46 C 16.8 58.21 5.8 47.2 5.04 33.5 H 6.5 c 0.83 0 1.5 -0.67 1.5 -1.5 s -0.67 -1.5 -1.5 -1.5 H 5.04 C 5.79 16.8 16.8 5.8 30.5 5.04 V 6.5 c 0 0.83 0.67 1.5 1.5 1.5 s 1.5 -0.67 1.5 -1.5 V 5.04 c 13.7 0.75 24.7 11.76 25.46 25.46 H 57.5 c -0.83 0 -1.5 0.67 -1.5 1.5 s 0.67 1.5 1.5 1.5 h 1.46 C 58.21 47.2 47.2 58.2 33.5 58.96 Z M 36.05 33.93 c 0.28 -0.59 0.45 -1.24 0.45 -1.93 c 0 -1.95 -1.26 -3.6 -3 -4.22 V 12.5 c 0 -0.83 -0.67 -1.5 -1.5 -1.5 s -1.5 0.67 -1.5 1.5 v 15.28 c -1.74 0.62 -3 2.27 -3 4.22 c 0 2.48 2.02 4.5 4.5 4.5 c 0.69 0 1.34 -0.17 1.93 -0.45 l 8.25 8.25 c 0.29 0.29 0.68 0.44 1.06 0.44 s 0.77 -0.15 1.06 -0.44 c 0.59 -0.59 0.59 -1.54 0 -2.12 l -8.25 -8.25 Z M 32 33.5 c -0.83 0 -1.5 -0.67 -1.5 -1.5 s 0.67 -1.5 1.5 -1.5 s 1.5 0.67 1.5 1.5 s -0.67 1.5 -1.5 1.5 Z" fill="rgb(160 13 12)"/></svg>'); */
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" fill="rgb(160 13 12)"/></svg>');
  background-repeat: no-repeat;
}

.icon-info::before {
  content: '';
  display: block;
  height: 30px;
  width: 30px;
  background-size: 30px 30px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z M12 10c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1Z" fill="rgb(160 13 12)"></path><circle cx="12" cy="7.2" r="1.2" fill="rgb(160 13 12)"></circle></svg>');
  background-repeat: no-repeat;
}

.icon-arrow-left.red::before {
  content: '';
  display: inline-block;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.79 21c-.26 0-.51-.1-.71-.29l-7.29-7.29c-.78-.78-.78-2.05 0-2.83l7.29-7.29a.996.996 0 1 1 1.41 1.41L9.2 12l7.29 7.29a.996.996 0 0 1-.71 1.7Z" fill="rgb(160 13 12)"/></svg>');
  background-repeat: no-repeat;
  vertical-align: top;
  margin: 7px 0 0 0;
}

.icon-arrow-up::before {
  content: '';
  display: block;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M3 15.79c0-.26.1-.51.29-.71l7.29-7.29c.78-.78 2.05-.78 2.83 0l7.29 7.29a.996.996 0 1 1-1.41 1.41L12 9.2l-7.29 7.29a.996.996 0 0 1-1.7-.71Z" fill="rgb(160 13 12)"/></svg>');
  background-repeat: no-repeat;
  margin-top: 5px;
}

.icon-arrow-down::before {
  content: '';
  display: block;
  height: 15px;
  width: 15px;
  background-size: 15px 15px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 8.21c0 .26-.1.51-.29.71l-7.29 7.29c-.78.78-2.05.78-2.83 0L3.3 8.92a.996.996 0 1 1 1.41-1.41L12 14.8l7.29-7.29a.996.996 0 0 1 1.7.71Z" fill="rgb(160 13 12)"/></svg>');
  background-repeat: no-repeat;
  margin-top: 5px;
}
